import { errorLoading, loading, loaded, responseHandler, errorGetStatus,
  tokenInterceptor } from '../manager/HttpManager'
import { fetchLogoutAction } from './AuthWS'
import Constants from '../constants/Constants'

let urlServer = Constants.UrlsConstants.urlServer

let pageBeacon = 1
let maxPageBeacon = 1
let limitBeacon = 50
let isFetchingDatasBeacon = false

export const beaconWS = (state = { configBeacon: {},
  beacons: [], beaconActions: []}, action) => {
  switch (action.type) {
    case Constants.ActionsConstants.APPS.SET_APP_BEACON_CONFIG:
      return Object.assign({}, state, { configBeacon: action.datas })
    case Constants.ActionsConstants.APPS.SET_BEACONS:
      return Object.assign({}, state, { beacons: state.beacons.concat(action.datas.content) })
    case Constants.ActionsConstants.APPS.SET_BEACON:
      let idToSearch = action.datas.id || action.datas
      let beaconsList = JSON.parse(JSON.stringify(state.beacons))
      let indexOfBeacon = -1
      beaconsList.map((beacon, index) => {
        if (beacon.id === idToSearch) {
          indexOfBeacon = index
        }
        return null
      })
      if (indexOfBeacon >= 0) {
        if (action.datas.id) {
          beaconsList[indexOfBeacon] = action.datas
        } else {
          beaconsList.splice(indexOfBeacon, 1)
        }
      } else {
        if (action.datas.id) {
          beaconsList.unshift(action.datas)
        }
      }
      return Object.assign({}, state, { beacons: beaconsList })
    case Constants.ActionsConstants.APPS.CLEAR_BEACONS:
      return Object.assign({}, state, { beacons: [] })
    case Constants.ActionsConstants.APPS.SET_BEACON_ACTIONS:
      return Object.assign({}, state, { beaconActions: action.datas.content })
    default:
      return state
  }
}

export const setConfigBeacon = (data) => {
  return {
    type: Constants.ActionsConstants.APPS.SET_APP_BEACON_CONFIG,
    datas: data,
  }
}

export const setBeacons = (data) => {
  return {
    type: Constants.ActionsConstants.APPS.SET_BEACONS,
    datas: data,
  }
}

export const setBeacon = (data) => {
  return {
    type: Constants.ActionsConstants.APPS.SET_BEACON,
    datas: data,
  }
}

export const clearBeacons = () => {
  return {
    type: Constants.ActionsConstants.APPS.CLEAR_BEACONS,
  }
}

export const setBeaconActions = (data) => {
  return {
    type: Constants.ActionsConstants.APPS.SET_BEACON_ACTIONS,
    datas: data,
  }
}

export function fetchAppsBeaconActions (dispatch, appid = null, action) {
  function clearBeaconActions () {
    dispatch(setBeaconActions({content: []}))
  }

  function fetchBeaconActions () {
    let entryPoint = Constants.UrlsConstants.iotBeaconEntryPoint
    let method = Constants.MethodsWSConstants.IOT.FETCH_BEACON_ACTIONS

    fetch(urlServer+entryPoint+method+appid+'?page=1&sort=id&size=50', {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
    .then(response => {
      tokenInterceptor(response)
      return responseHandler(response)
    })
    .then(r => r.json())
    .then(data => {
      dispatch(setBeaconActions(data))
    })
    .catch(error => {
      if (errorGetStatus(error) === 401) {
        dispatch(errorLoading('Error.Croutons.authExpired'))
        fetchLogoutAction(dispatch).fetchLogout()
      }
    })
  }

  function saveActions () {
    let entryPoint = Constants.UrlsConstants.iotBeaconEntryPoint
    let method = Constants.MethodsWSConstants.IOT.UPDATE_BEACON_ACTIONS

    fetch(urlServer+entryPoint+method, {
      method: 'PUT',
      headers: Constants.UrlsConstants.header,
      body: JSON.stringify(action),
    })
    .then(response => {
      tokenInterceptor(response)
      return responseHandler(response)
    })
    .then(r => r.json())
    .then(data => {
      // dispatch(setBeaconActions(data))
      dispatch(loaded('Error.Croutons.saveSuccess'))
      pageBeacon = 1
      maxPageBeacon = 1
      limitBeacon = 50
      dispatch(clearBeacons())
      fetchAppsBeacons(dispatch, appid).fetchBeacons()
      fetchBeaconActions()
    })
    .catch(error => {
      if (errorGetStatus(error) === 401) {
        dispatch(errorLoading('Error.Croutons.authExpired'))
        fetchLogoutAction(dispatch).fetchLogout()
      }
    })
  }

  function deleteActions () {
    let entryPoint = Constants.UrlsConstants.iotBeaconEntryPoint
    let method = Constants.MethodsWSConstants.IOT.DELETE_ACTION+action.id

    fetch(urlServer+entryPoint+method, {
      method: 'DELETE',
      headers: Constants.UrlsConstants.header,
      body: JSON.stringify(action),
    })
    .then(response => {
      tokenInterceptor(response)
      return responseHandler(response)
    })
    // .then(r => r.json())
    .then(() => {
      dispatch(loaded('Error.Croutons.deleteSuccess'))
      pageBeacon = 1
      maxPageBeacon = 1
      limitBeacon = 50
      dispatch(clearBeacons())
      fetchAppsBeacons(dispatch, appid).fetchBeacons()
      fetchBeaconActions()
    })
    .catch(error => {
      if (errorGetStatus(error) === 401) {
        dispatch(errorLoading('Error.Croutons.authExpired'))
        fetchLogoutAction(dispatch).fetchLogout()
      }
    })
  }

  return {
    clearBeaconActions,
    fetchBeaconActions,
    saveActions,
    deleteActions,
  }
}

export function fetchAppsBeacons (dispatch, appid = null, beaconActive = false, typeBeacon = null, beacon = null) {
  function fetchStateBeacon () {
    let entryPoint = Constants.UrlsConstants.appsEntryPoint+Constants.MethodsWSConstants.APPS.DETAIL_APP
    let method = appid + '/' + Constants.MethodsWSConstants.APPS.FETCH_APP_BEACON

    // dispatch(loading(method))
    fetch(urlServer+entryPoint+method, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
    .then(response => {
      tokenInterceptor(response)
      return responseHandler(response)
    })
    .then(r => r.json())
    .then(data => {
      // dispatch(loaded(method))
      dispatch(setConfigBeacon(data))
    })
    .catch(error => {
      // dispatch(errorLoading(method))
      if (errorGetStatus(error) === 401) {
        dispatch(errorLoading('Error.Croutons.authExpired'))
        fetchLogoutAction(dispatch).fetchLogout()
      }
    })
  }

  function updateStateBeacon () {
    let entryPoint = Constants.UrlsConstants.appsEntryPoint
    let method = Constants.MethodsWSConstants.APPS.UPDATE_APP_BEACON
    let dataNav = {'id': appid, 'beaconActive': beaconActive, 'typeBeacon': typeBeacon}

    // dispatch(loading(method))
    fetch(urlServer+entryPoint+method, {
      method: 'PUT',
      body: JSON.stringify(dataNav),
      headers: Constants.UrlsConstants.header,
    })
    .then(response => {
      tokenInterceptor(response)
      return responseHandler(response)
    })
    .then(r => r.json())
    .then(data => {
      dispatch(loaded('Error.Croutons.saveSuccess'))
      // dispatch(loaded(method))
      fetchStateBeacon()
    })
    .catch(error => {
      // dispatch(errorLoading(method))
      if (errorGetStatus(error) === 401) {
        dispatch(errorLoading('Error.Croutons.authExpired'))
        fetchLogoutAction(dispatch).fetchLogout()
      } else {
        dispatch(errorLoading('Error.Croutons.saveError'))
      }
    })
  }

  function fetchBeacons (loadedMessage) {
    if (pageBeacon <= maxPageBeacon && !isFetchingDatasBeacon) {
      isFetchingDatasBeacon = true
      let entryPoint = Constants.UrlsConstants.iotBeaconEntryPoint
      let method = Constants.MethodsWSConstants.IOT.FETCH_BEACONS + appid

      if (pageBeacon <= maxPageBeacon) {
        dispatch(loading(''))
        fetch(urlServer+entryPoint+method+'?page='+pageBeacon+'&size='+limitBeacon+'&sort=id&dir=DESC', {
          method: 'GET',
          headers: Constants.UrlsConstants.header,
        })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
        .then(r => r.json())
        .then(data => {
          maxPageBeacon = data.totalPages
          if (maxPageBeacon >= pageBeacon) pageBeacon++
          isFetchingDatasBeacon = false
          dispatch(setBeacons(data))
          if (loadedMessage) {
            dispatch(loaded(loadedMessage))
          } else {
            dispatch(loaded(''))
          }
        })
        .catch(error => {
          // dispatch(errorLoading(method))
          if (errorGetStatus(error) === 401) {
            dispatch(errorLoading('Error.Croutons.authExpired'))
            fetchLogoutAction(dispatch).fetchLogout()
            // window.location.href='/'
          }
        })
      }
    }
  }

  function saveBeacon () {
    let entryPoint = Constants.UrlsConstants.iotBeaconEntryPoint
    let method = Constants.MethodsWSConstants.IOT.UPDATE_BEACON
    if (!beacon.id) {
      // Create new beacon
      method = Constants.MethodsWSConstants.IOT.CREATE_BEACON+appid
    }
    fetch(urlServer+entryPoint+method, {
      method: beacon.id ? 'PUT' : 'POST',
      body: JSON.stringify(beacon),
      headers: Constants.UrlsConstants.header,
    })
    .then(response => {
      tokenInterceptor(response)
      return responseHandler(response)
    })
    .then(r => r.json())
    .then(data => {
      dispatch(loaded('Error.Croutons.saveSuccess'))
      dispatch(setBeacon(data))
      fetchAppsBeaconActions(dispatch, appid).fetchBeaconActions()
    })
    .catch(error => {
      // dispatch(errorLoading(method))
      if (errorGetStatus(error) === 401) {
        dispatch(errorLoading('Error.Croutons.authExpired'))
        fetchLogoutAction(dispatch).fetchLogout()
        // window.location.href='/'
      } else {
        dispatch(errorLoading('Error.Croutons.saveError'))
      }
    })
  }

  function deleteBeacon () {
    let entryPoint = Constants.UrlsConstants.iotBeaconEntryPoint
    let method = Constants.MethodsWSConstants.IOT.DELETE_BEACON+beacon.id

    fetch(urlServer+entryPoint+method, {
      method: 'DELETE',
      headers: Constants.UrlsConstants.header,
    })
    .then(response => {
      tokenInterceptor(response)
      return responseHandler(response)
    })
    // .then(r => r.json())
    .then(data => {
      dispatch(loaded('Error.Croutons.deleteSuccess'))
      dispatch(setBeacon(beacon.id))
      fetchAppsBeaconActions(dispatch, appid).fetchBeaconActions()
    })
    .catch(error => {
      // dispatch(errorLoading(method))
      if (errorGetStatus(error) === 401) {
        dispatch(errorLoading('Error.Croutons.authExpired'))
        fetchLogoutAction(dispatch).fetchLogout()
        // window.location.href='/'
      } else {
        dispatch(errorLoading('Error.Croutons.deleteError'))
      }
    })
  }

  function clearBeaconsFromStore () {
    pageBeacon = 1
    maxPageBeacon = 1
    limitBeacon = 50
    isFetchingDatasBeacon = false
    dispatch(clearBeacons())
  }

  return {
    fetchStateBeacon,
    updateStateBeacon,
    fetchBeacons,
    saveBeacon,
    clearBeaconsFromStore,
    deleteBeacon,
  }
}
